export const COLD_OUTREACH_TAG_NAME = 'Cold Inbound';
export const COLD_OUTREACH_LABEL = 'cold outreach';

export const LEGACY_COLD_OUTREACH_TAG_NAMES = [
  'Cold Outbound',
] as const;

const normalizeTagName = (tagName: string): string => tagName.trim().toLowerCase();

const COLD_OUTREACH_TAG_KEYS = new Set(
  [COLD_OUTREACH_TAG_NAME, ...LEGACY_COLD_OUTREACH_TAG_NAMES].map(normalizeTagName)
);

export const isColdOutreachTagName = (tagName: string | null | undefined): boolean => {
  if (!tagName) {
    return false;
  }

  return COLD_OUTREACH_TAG_KEYS.has(normalizeTagName(tagName));
};
